var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6756 5.1225L2.17 0.0600004C1.9466 -0.00515846 1.7111 -0.0174453 1.48213 0.0241113C1.25316 0.065668 1.037 0.159928 0.850749 0.299438C0.664495 0.438947 0.513253 0.619878 0.408987 0.827922C0.304722 1.03597 0.250291 1.26542 0.25 1.49813V14.9981C0.25 15.396 0.408035 15.7775 0.68934 16.0588C0.970644 16.3401 1.35218 16.4981 1.75 16.4981C1.89344 16.4982 2.03614 16.4777 2.17375 16.4372L10 14.0353V14.9981C10 15.396 10.158 15.7775 10.4393 16.0588C10.7206 16.3401 11.1022 16.4981 11.5 16.4981H14.5C14.8978 16.4981 15.2794 16.3401 15.5607 16.0588C15.842 15.7775 16 15.396 16 14.9981V12.195L18.6756 11.3747C18.9853 11.2816 19.2569 11.0916 19.4503 10.8325C19.6437 10.5734 19.7488 10.259 19.75 9.93563V6.56063C19.7486 6.23745 19.6434 5.92326 19.45 5.66435C19.2566 5.40544 18.9851 5.2155 18.6756 5.1225ZM14.5 14.9981H11.5V13.575L14.5 12.6544V14.9981ZM18.25 9.93563H18.2397L11.5 12.0056V4.48969L18.2397 6.56063H18.25V9.93563Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementIcon);
export default __webpack_public_path__ + "static/media/AnnouncementIcon.5fe15bedd6216e3abcfd21b32f4563c9.svg";
export { ForwardRef as ReactComponent };